module.exports = __webpack_public_path__ + "47eaaf516afdeaa6dc685d241c923d62.svg";